const awards = [
  {
    name: "🎓 Tencent Project UP（青云计划）",
    year: "2026",
    organization: "Tencent",
    description: "Project UP（青云计划） is Tencent's talent program for top global tech students, aiming to nurture future technology leaders through cutting-edge research opportunities and mentorship."
  },
  {
    name: "{fig:./imgs/profile/Tencent_Logo.svg} 2025 Tencent Rhino-bird Research Elite Program",
    year: "2025",
    organization: "Tencent",
    description: "This program aims to select students who are passionate and have potential in scientific research, helping them explore the path of research, and working with universities to cultivate a group of pioneers who dare to seek truth and support technological innovation."
  },
  {
    name: "🥉 1st Semi-supervised Teeth Segmentation MICCAI Challenge, Third Place Award",
    year: "2024",
    organization: "MICCAI 2023 ToothFairy",
    description: "Teeth CBCT Semi-supervised Domain Adaptation Semantic Segmentation Challenge"
  },
  {
    name: "🎉 China Undergraduate Mathematical Contest in Modeling, National First Prize",
    year: "2024",
    organization: "CSIAM",
    description: "China Undergraduate Mathematical Contest in Modeling"
  },
  {
    name: "🎉 Mathematical Contest in Modeling, Finalist",
    year: "2024",
    organization: "COMAP",
    description: "The designation Finalist recognizes teams whose solution reports are exemplary and therefore reached the final round of judging. These papers present complete and logical analysis in an organized and clear presentation above and beyond simply addressing the requirements. These papers are easy to read, easy to follow, logical, and comprehensive. Finalist papers are among the best of all team submissions."
  },
  {
    name: "🎓 National Scholarship",
    year: "202{3/4/5}",
    organization: "Ministry of Education",
    description: "Highest honor for undergraduate students in China, awarded to top 0.2% students nationwide."
  }
];

export default awards;